import { ButtonLink } from '@designsforhealth/dfh-react-components'
import { Button } from '@dfh-corp-sites/ui'
import React, { useState } from 'react'

import { isProductInStock } from '../../lib/cart/item'
import { CartItem } from '../../lib/cart/types'
import { Alert } from '../Alert'
import Modal from '../Modal'

export interface StockAlertAndModalProps {
  item: CartItem
}

const StockAlertAndModal: React.FC<StockAlertAndModalProps> = ({ item }) => {
  const [isStockModalOpen, setIsStockModalOpen] = useState(false)
  const toggleStockModal = () => {
    setIsStockModalOpen(!isStockModalOpen)
  }

  // TODO: add a check for out of stock status to render alternative messaging
  const stockMessage = !isProductInStock(item.product)
    ? item.product.out_of_stock_message || 'Out of stock'
    : undefined

  if (!stockMessage) {
    return null
  }

  return (
    <>
      <Alert type="error" className="mt-2.5">
        This product is on backorder.{' '}
        <ButtonLink onClick={toggleStockModal} className="font-gotham font-medium !underline">
          Click for details
        </ButtonLink>
      </Alert>
      <Modal
        isOpen={isStockModalOpen}
        onClose={toggleStockModal}
        content={stockMessage}
        cta={
          <Button variant="secondary" onClick={toggleStockModal}>
            Close
          </Button>
        }
      />
    </>
  )
}

export default StockAlertAndModal
